import React from 'react';
import './ModalTableTariffs.scss';
import './ModalTableTariffs-media.scss';
import { MediaContent } from '../../services/GlobalFunctions';
import { Props } from './interfaces';
import { connect, WithStore, MapStateToProps, MapDispatchToProps } from '../../redux/services/Imports';
import Table from '../Table/Table';
import List from '../List/List';
import { createPortal } from 'react-dom';

const ModalTableTariffs = ({ title, closedModal, tariffs, nodeRef }: Props) => {
  const { dataTariffs, dataDopTariffs, list, headTable, headDopTable } = tariffs;

  const Table1 = (
    <Table
      data={dataTariffs}
      headLight={
        <tr className="table__head-white">
          {headTable.map((item, i) => (
            <td key={i}>
              <h5 className="body2" dangerouslySetInnerHTML={{ __html: item }}></h5>
            </td>
          ))}
        </tr>
      }
    />
  );

  return createPortal(
    <>
      <div ref={nodeRef} className="modal-table-tariffs">
        <div className="modal-table-tariffs__close" onClick={closedModal}></div>
        <h2 className="modal-table-tariffs__title">{title}</h2>

        {MediaContent(<div className="modal-table-tariffs__table">{Table1}</div>, Table1)}

        <div className="modal-table-tariffs__list">
          {list.map((item, i) => (
            <List {...item} check key={i} />
          ))}
        </div>

        <Table
          data={dataDopTariffs}
          headLight={
            <tr className="table__head-white">
              {headDopTable.map((item, i) => (
                <td key={i}>
                  <h5 className="body2" dangerouslySetInnerHTML={{ __html: item }}></h5>
                </td>
              ))}
            </tr>
          }
        />
      </div>

      <div className="modal-bg" onClick={closedModal}></div>
    </>,
    document.body
  );
};

export default WithStore()(connect(MapStateToProps, MapDispatchToProps)(ModalTableTariffs));
